/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/7/11
 */
import config from 'crm/config'

const authApi = `${config.apiHost}/oem-auth`

export default {
    info: {
        url: `${authApi}/api/companies/info`,
        type: 'GET',
    },
    update: {
        url: `${authApi}/api/companies/info`,
        type: 'PUT',
    },
    secret: {
        url: `${authApi}/api/companies/secrets`,
        type: 'GET',
    },
}
